import React, { useState } from 'react';
import { makeStyles } from 'design-system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useProjectInstructionContext } from '../projectInstructionContext';

const Section = ({
  sectionName,
  isNew,
  children,
  defaultOpen,
}: {
  sectionName: JSX.Element | string;
  isNew?: boolean;
  children: JSX.Element | JSX.Element[];
  defaultOpen?: boolean;
}) => {
  const classes = useStyles();
  const { isMobileView } = useProjectInstructionContext();
  const [open, setOpen] = useState<boolean>(defaultOpen ?? true);

  return (
    <div className={isMobileView ? classes.emptyStyle : classes.container}>
      <div
        className={classes.sectionName}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <span>
          {sectionName}
          {isNew && <span style={{ color: 'var(--color-RemoRed' }}> New!</span>}
        </span>
        <span className={classes.toggle}>
          <FontAwesomeIcon icon={open ? 'chevron-down' : 'chevron-up'} />
        </span>
      </div>
      {open && (
        <div
          className={isMobileView ? classes.sidePanelContentStyle : classes.fullPageContentStyle}
        >
          {children}
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    borderRadius: 7,
    border: `1px solid ${theme.colors.gray10}`,
    overflow: 'hidden',
    marginTop: 15,
  },
  emptyStyle: {},
  sectionName: {
    fontWeight: 500,
    fontSize: 13,
    color: theme.colors.gray50,
    background: theme.colors.gray05,
    display: 'flex',
    alignItems: 'center',
    padding: '10px 20px',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    '-webkit-user-select': 'none' /* Safari */,
    '-moz-user-select': 'none' /* Firefox */,
    '-ms-user-select': 'none' /* IE10+/Edge */,
    'user-select': 'none' /* Standard */,
  },
  sidePanelContentStyle: {
    padding: '5px 10px',
    '&  p': {
      lineHeight: 1.4,
    },
  },

  fullPageContentStyle: {
    padding: '10px 20px',
    '&  p': {
      margin: 0,
    },
    '&  strong': {
      fontWeight: 700,
    },
  },

  toggle: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default Section;
